<template>
  <hello-world />
</template>

<script>
  import HelloWorld from '../components/HelloWorld'
  import { getAlluser,  getAllOptix , getAllWestnet , getAllBitway , getAllTecnicos , getAllTotales }from '../database.js'
  // import EquipoStore from "../store/index";
  import { mapState } from 'vuex'
  export default {
    name: 'Home',

    components: {
      HelloWorld,
    },
    async created() {
    await getAlluser()
    await getAllOptix()
    await getAllWestnet()
    await getAllBitway()
    await getAllTecnicos()
    await getAllTotales()
    this.userInit()
  },
  computed:{
      ...mapState({
     userlogged: state => state.userLogged, 
     users: state => state.users,
     userAuth: state => state.userAuth,
     auth: state => state.auth,
     userType: state => state.userType,
     userEmpresas: state => state.userEmpresas,
    })
      
  },
  methods: {
    userInit(){     
      let user = this.userlogged   
      let list = this.users 
      let result = list.find(item => item.email === user); 
      this.$store.commit('SET_USERAUTH', result)    
      // EquipoStore.data.userAuth = result
      this.$store.commit('SET_AUTH', true) 
      // EquipoStore.data.auth = true
      let rol = this.userAuth.rol
      let empresas = this.userAuth.empresa
      this.$store.commit('SET_USERTYPE', rol)
      this.$store.commit('SET_USEREMPRESAS', empresas)
      // EquipoStore.data.userType=EquipoStore.data.userAuth.rol
      console.log( "usuario autenticado: ",this.userType); 
      console.log( "usuario autenticado: ",this.userAuth); 
      console.log( "usuario empresa: ",this.userEmpresas); 
    }
  },
  }
</script>
